@if (cell.parseHtml) {
  @if (cell.wrapText) {
    <sh-html-parser class="sh-wrap-text" [message]="cell.value" [title]="cell.tooltip ?? cell.value"></sh-html-parser>
  } @else {
    <sh-list-row-title [title]="cell.value" [minWidthInRem]="cell.minWidthInRem"></sh-list-row-title>
  }
}

@if (!cell.parseHtml) {
  @if (cell.wrapText) {
    <span class="sh-wrap-text" [ngClass]="{'-sh-disabled': cell.disabled}" [innerHtml]="cell.value"></span>
  } @else {
    <sh-list-row-title [title]="cell.value" [minWidthInRem]="cell.minWidthInRem"></sh-list-row-title>
  }
}

